import { FAQResponse } from '@/core/domain/faqs/models/faqs.model';
import { FAQRepository } from '@/core/domain/faqs/repositories/faqs.repository';
import { environment } from '@/env/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, switchMap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class FAQsImplRepository extends FAQRepository {
    constructor(private readonly httpClient: HttpClient) {
        super();
    }

    override getFAQs(): Observable<FAQResponse> {
        return this.httpClient
            .get(
                [
                    environment.alamoApi.BASE_HOST,
                    environment.alamoApi.ENDPOINTS.faqs,
                ].join('/'),
            )
            .pipe(
                switchMap((faqsResponse: FAQResponse) => {
                    const faqs: FAQResponse = {
                        type: faqsResponse.type,
                        action: faqsResponse.action,
                        notifications: faqsResponse.notifications,
                        data: faqsResponse.data,
                    };

                    return of(faqs);
                }),
            );
    }
}
